import React, { useEffect, useRef, useState } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import './ArcadeModal.css';
import './Snake.css';

const CELL = 20;
const COLS = 17;
const ROWS = 17;
const W = CELL * COLS; // 340
const H = CELL * ROWS; // 340

// La "comida" es una taquilla mini (el mismo thumbnail que usa BuscaMinis como VACWAYmini).
const FOOD_SRC = '/images/machines/small_thumb.png';

// Nivel del slider (1 lento .. 5 rápido) -> ms por paso. Por defecto arranca lento.
const STEP_MS = { 1: 220, 2: 175, 3: 135, 4: 100, 5: 72 };
const VELO_LABEL = { 1: 'Muy lento', 2: 'Lento', 3: 'Normal', 4: 'Rápido', 5: 'Muy rápido' };

const DIRS = {
  up: { x: 0, y: -1 },
  down: { x: 0, y: 1 },
  left: { x: -1, y: 0 },
  right: { x: 1, y: 0 },
};

function reset(g) {
  const cx = Math.floor(COLS / 2);
  const cy = Math.floor(ROWS / 2);
  g.state = 'idle';
  g.snake = [{ x: cx, y: cy }, { x: cx - 1, y: cy }, { x: cx - 2, y: cy }];
  g.dir = DIRS.right;
  g.nextDir = DIRS.right;
  g.turnLocked = false;
  g.score = 0;
}

function placeFood(g) {
  // Celda libre aleatoria (no sobre la serpiente).
  let x, y;
  do {
    x = Math.floor(Math.random() * COLS);
    y = Math.floor(Math.random() * ROWS);
  } while (g.snake.some((s) => s.x === x && s.y === y));
  g.food = { x, y };
}

function step(g) {
  g.dir = g.nextDir;
  g.turnLocked = false;

  const head = g.snake[0];
  const nx = head.x + g.dir.x;
  const ny = head.y + g.dir.y;

  // Paredes
  if (nx < 0 || nx >= COLS || ny < 0 || ny >= ROWS) {
    g.state = 'dead';
    if (g.score > g.best) g.best = g.score;
    return;
  }

  const willEat = nx === g.food.x && ny === g.food.y;
  // La cola se libera salvo que crezcamos al comer.
  const body = willEat ? g.snake : g.snake.slice(0, -1);
  if (body.some((s) => s.x === nx && s.y === ny)) {
    g.state = 'dead';
    if (g.score > g.best) g.best = g.score;
    return;
  }

  g.snake.unshift({ x: nx, y: ny });
  if (willEat) {
    g.score++;
    if (g.score > g.best) g.best = g.score;
    placeFood(g);
  } else {
    g.snake.pop();
  }
}

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

function lerp3(a, b, t) {
  return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t];
}

function drawEyes(ctx, head, dir) {
  const cx = head.x * CELL;
  const cy = head.y * CELL;
  let e1, e2;
  if (dir.x === -1) { e1 = [cx + 6, cy + 6]; e2 = [cx + 6, cy + CELL - 6]; }
  else if (dir.x === 1) { e1 = [cx + CELL - 6, cy + 6]; e2 = [cx + CELL - 6, cy + CELL - 6]; }
  else if (dir.y === -1) { e1 = [cx + 6, cy + 6]; e2 = [cx + CELL - 6, cy + 6]; }
  else { e1 = [cx + 6, cy + CELL - 6]; e2 = [cx + CELL - 6, cy + CELL - 6]; }

  ctx.fillStyle = '#fff';
  ctx.beginPath();
  ctx.arc(e1[0], e1[1], 3, 0, Math.PI * 2);
  ctx.arc(e2[0], e2[1], 3, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#0f172a';
  ctx.beginPath();
  ctx.arc(e1[0] + dir.x, e1[1] + dir.y, 1.5, 0, Math.PI * 2);
  ctx.arc(e2[0] + dir.x, e2[1] + dir.y, 1.5, 0, Math.PI * 2);
  ctx.fill();
}

function panel(ctx, lines, isDead) {
  ctx.fillStyle = 'rgba(247, 249, 252, 0.92)';
  ctx.fillRect(0, 0, W, H);
  ctx.textAlign = 'center';
  const cx = W / 2;
  ctx.font = 'bold 22px Manrope, sans-serif';
  ctx.fillStyle = isDead ? '#dc2626' : '#0f172a';
  ctx.fillText(lines[0], cx, H / 2 - 46);
  ctx.fillStyle = '#334155';
  ctx.font = '15px Manrope, sans-serif';
  for (let i = 1; i < lines.length - 1; i++) {
    ctx.fillText(lines[i], cx, H / 2 - 12 + (i - 1) * 26);
  }
  ctx.font = '13px Manrope, sans-serif';
  ctx.fillStyle = '#64748b';
  ctx.fillText(lines[lines.length - 1], cx, H / 2 + 52);
}

function draw(ctx, g, foodImg) {
  // fondo claro + rejilla sutil
  ctx.fillStyle = '#eef2f7';
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = 'rgba(148, 163, 184, 0.16)';
  ctx.lineWidth = 1;
  for (let i = 1; i < COLS; i++) {
    ctx.beginPath();
    ctx.moveTo(i * CELL + 0.5, 0);
    ctx.lineTo(i * CELL + 0.5, H);
    ctx.stroke();
  }
  for (let j = 1; j < ROWS; j++) {
    ctx.beginPath();
    ctx.moveTo(0, j * CELL + 0.5);
    ctx.lineTo(W, j * CELL + 0.5);
    ctx.stroke();
  }

  // comida (taquilla mini)
  const fx = g.food.x * CELL;
  const fy = g.food.y * CELL;
  if (foodImg && foodImg.complete && foodImg.naturalWidth > 0) {
    ctx.save();
    ctx.shadowColor = 'rgba(2, 32, 64, 0.25)';
    ctx.shadowBlur = 4;
    ctx.shadowOffsetY = 1;
    ctx.drawImage(foodImg, fx + 2, fy + 2, CELL - 4, CELL - 4);
    ctx.restore();
  } else {
    ctx.fillStyle = '#f59e0b';
    roundRect(ctx, fx + 3, fy + 3, CELL - 6, CELL - 6, 4);
    ctx.fill();
  }

  // serpiente (degradado azul cabeza -> cola)
  const n = g.snake.length;
  for (let i = n - 1; i >= 0; i--) {
    const s = g.snake[i];
    const t = n > 1 ? i / (n - 1) : 0;
    const c = lerp3([37, 99, 235], [125, 185, 255], t);
    ctx.fillStyle = `rgb(${c[0] | 0}, ${c[1] | 0}, ${c[2] | 0})`;
    roundRect(ctx, s.x * CELL + 1.5, s.y * CELL + 1.5, CELL - 3, CELL - 3, 6);
    ctx.fill();
  }
  if (n) drawEyes(ctx, g.snake[0], g.dir);

  if (g.state === 'idle') {
    panel(ctx, ['🐍 SNAKE LOCKER', 'Flechas / WASD para moverte', 'Come las taquillas mini', 'Clic o [Espacio] para empezar'], false);
  } else if (g.state === 'dead') {
    panel(ctx, ['¡GAME OVER!', `Puntuación: ${g.score}`, `🏆 Mejor: ${g.best}`, 'Clic o [Espacio] para reintentar'], true);
  }
}

const Snake = ({ isOpen, toggle }) => {
  const canvasRef = useRef(null);
  const foodImgRef = useRef(null);
  const timeoutRef = useRef(null);
  const actionRef = useRef(null);
  const stepMsRef = useRef(STEP_MS[1]);
  const gRef = useRef({ best: 0, state: 'idle', snake: [], dir: DIRS.right, nextDir: DIRS.right, turnLocked: false, score: 0, food: { x: 0, y: 0 } });

  const [uiScore, setUiScore] = useState(0);
  const [uiState, setUiState] = useState('idle');
  const [velocity, setVelocity] = useState(1);

  // Precarga la imagen de la taquilla una vez.
  useEffect(() => {
    const img = new window.Image();
    img.src = FOOD_SRC;
    foodImgRef.current = img;
  }, []);

  useEffect(() => {
    clearTimeout(timeoutRef.current);
    if (!isOpen) return;

    const canvas = canvasRef.current;
    if (!canvas) return;
    const dpr = window.devicePixelRatio || 1;
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    canvas.style.width = W + 'px';
    canvas.style.height = H + 'px';
    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    const g = gRef.current;
    const best = g.best || 0;
    reset(g);
    g.best = best;
    placeFood(g);
    setUiScore(0);
    setUiState('idle');

    const render = () => draw(ctx, g, foodImgRef.current);

    const loop = () => {
      step(g);
      render();
      setUiScore(g.score);
      if (g.state === 'dead') {
        setUiState('dead');
        return;
      }
      timeoutRef.current = setTimeout(loop, stepMsRef.current);
    };

    const start = () => {
      if (g.state === 'playing') return;
      if (g.state === 'dead') {
        const b = g.best;
        reset(g);
        g.best = b;
        placeFood(g);
      }
      g.state = 'playing';
      setUiState('playing');
      setUiScore(0);
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(loop, stepMsRef.current);
    };
    actionRef.current = start;

    render();

    const turn = (nd) => {
      // Nunca girar 180º: al arrancar la cola está a la izquierda, así que ir a la
      // izquierda sería chocar contra el propio cuerpo al instante.
      if (nd.x === -g.dir.x && nd.y === -g.dir.y) return;
      if (g.state === 'idle') {
        g.dir = nd;
        g.nextDir = nd;
        start();
        return;
      }
      if (g.state !== 'playing' || g.turnLocked) return;
      g.nextDir = nd;
      g.turnLocked = true;
    };

    const onKey = (e) => {
      const k = e.key.toLowerCase();
      if (k === ' ' || k === 'enter') { e.preventDefault(); start(); return; }
      let nd = null;
      if (k === 'arrowup' || k === 'w') nd = DIRS.up;
      else if (k === 'arrowdown' || k === 's') nd = DIRS.down;
      else if (k === 'arrowleft' || k === 'a') nd = DIRS.left;
      else if (k === 'arrowright' || k === 'd') nd = DIRS.right;
      if (!nd) return;
      e.preventDefault();
      turn(nd);
    };
    window.addEventListener('keydown', onKey);

    // Swipe táctil para móvil
    let tx = 0, ty = 0;
    const onTouchStart = (e) => { const t = e.touches[0]; tx = t.clientX; ty = t.clientY; };
    const onTouchEnd = (e) => {
      const t = e.changedTouches[0];
      const dx = t.clientX - tx;
      const dy = t.clientY - ty;
      if (Math.abs(dx) < 20 && Math.abs(dy) < 20) { start(); return; }
      if (Math.abs(dx) > Math.abs(dy)) turn(dx > 0 ? DIRS.right : DIRS.left);
      else turn(dy > 0 ? DIRS.down : DIRS.up);
    };
    canvas.addEventListener('touchstart', onTouchStart, { passive: true });
    canvas.addEventListener('touchend', onTouchEnd, { passive: true });

    return () => {
      clearTimeout(timeoutRef.current);
      window.removeEventListener('keydown', onKey);
      canvas.removeEventListener('touchstart', onTouchStart);
      canvas.removeEventListener('touchend', onTouchEnd);
    };
  }, [isOpen]);

  const onVelocity = (e) => {
    const v = Number(e.target.value);
    setVelocity(v);
    stepMsRef.current = STEP_MS[v];
  };

  const hint =
    uiState === 'playing' ? 'Flechas o WASD para girar · come las taquillas'
      : uiState === 'dead' ? 'Clic en el tablero o [Espacio] para reintentar'
        : 'Flechas / WASD · clic o [Espacio] para empezar';

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered contentClassName="arcade-modal">
      <ModalHeader toggle={toggle} className="arcade-header" tag="div">
        <span className="arcade-title">
          <span className="arcade-icon" style={{ background: 'linear-gradient(135deg, #14b8a6, #0d9488)' }}>🐍</span>
          Snake Locker
        </span>
        <div className="arcade-actions">
          <span className="arcade-hud"><i className="fas fa-star"></i> {uiScore}</span>
        </div>
      </ModalHeader>
      <ModalBody className="arcade-body">
        <div className="snake-controls">
          <span className="snake-speed-label"><i className="fas fa-gauge-high"></i> Velocidad</span>
          <input
            className="snake-slider"
            type="range"
            min="1"
            max="5"
            step="1"
            value={velocity}
            onChange={onVelocity}
          />
          <span className="snake-speed-value">{VELO_LABEL[velocity]}</span>
        </div>
        <div className="snake-stage">
          <canvas
            ref={canvasRef}
            onClick={() => actionRef.current && actionRef.current()}
            style={{ cursor: 'pointer', display: 'block' }}
          />
        </div>
        <p className="arcade-hint">{hint}</p>
      </ModalBody>
    </Modal>
  );
};

export default Snake;
